module.exports = __webpack_public_path__ + "img/green_021.d9857205.png";